// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fca63654","320":"3ead672f"}[chunkId] + ".chunk.js";
};